import { Flex, Box, Divider, Image } from '@chakra-ui/react';
import Tooltip from '@molecules/BEOffScreen/Tooltip';
import { BEPopover, PopoverProps } from '@molecules/BEOffScreen/Popover';

const TestToolTip = ({
  imageUrl,
  ...popoverProps
}: PopoverProps & { imageUrl: string }) => {
  return (
    <BEPopover {...popoverProps}>
      <Image w="160px" h="120px" src={imageUrl} objectFit="cover" />
    </BEPopover>
  );
};

const DemoToolTip = () => {
  return (
    <Box>
      <h2>Tooltip</h2>
      <Divider m={2} />
      <Flex align={'center'} gap={8} p={8}>
        <Tooltip
          id="test1"
          Component={TestToolTip}
          imageUrl="https://media.giphy.com/media/393kszFi2PuCEopURN/giphy.gif"
          placement="top"
        >
          <div>
            This will show a tooltip at <b>TOP</b>.
          </div>
        </Tooltip>

        <Tooltip
          id="test2"
          Component={TestToolTip}
          imageUrl="https://media.giphy.com/media/3gYWogvLv5A0Nw9K6D/giphy.gif"
          placement="bottom"
        >
          <div>
            This will show a tooltip at <b>BOTTOM</b>.
          </div>
        </Tooltip>
      </Flex>
      <Divider />
      <Flex align={'center'} gap={8} p={8}>
        <Tooltip
          id="test3"
          Component={TestToolTip}
          imageUrl="https://media.giphy.com/media/DhstvI3zZ598Nb1rFf/giphy.gif"
          placement="left"
        >
          <div>
            This will show a tooltip at <b>LEFT</b>.
          </div>
        </Tooltip>

        <Tooltip
          id="test4"
          Component={TestToolTip}
          imageUrl="https://media.giphy.com/media/MIfrXbLj9RSMboER9g/giphy.gif"
          placement="right"
        >
          <div>
            This will show a tooltip at <b>RIGHT</b>.
          </div>
        </Tooltip>
      </Flex>
    </Box>
  );
};

export default DemoToolTip;
